import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Master";
import getToken from "app/api/getToken";
import { IMaster } from "app/api/types/Masters";

export const UPLOAD_MASTER_IMG_REQUEST = "UPLOAD_MASTER_IMG_REQUEST";
export const UPLOAD_MASTER_IMG_SUCCESS = "UPLOAD_MASTER_IMG_SUCCESS";
export const UPLOAD_MASTER_IMG_FAIL = "UPLOAD_MASTER_IMG_FAIL";

export const uploadMasterImg = (data: any, masterId: number) => (
  dispatch: any
): any => {
  dispatch({ type: UPLOAD_MASTER_IMG_REQUEST });

  const token = getToken();

  return api
    .uploadMasterImg(token, data, masterId)
    .then((response: AxiosResponse) => {
      const master: IMaster = get(response, "data", {});
      dispatch({ type: UPLOAD_MASTER_IMG_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: UPLOAD_MASTER_IMG_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
